<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6 offset-md-3">
        <h1>Reset Password</h1>

        <form v-if="!resetSent" @submit.prevent="performReset()" class="login-form">
          <div class="form-group">
            <label class="control-label" for="password">Password</label>
            <input id="password" v-model="password" @blur="$v.password.$touch()" type="password" class="form-control">
            <div v-if="$v.password.$error" class="val-error">
              <span v-if="!$v.password.required">Password is required.</span>
              <span v-if="!$v.password.minLength">Password must have at least {{ $v.password.$params.minLength.min }} letters.</span>
            </div>
          </div>
          <div class="form-group">
            <label class="control-label" for="passwordmatch">Verify Password</label>
            <input id="passwordmatch" v-model="passwordmatch" @blur="$v.passwordmatch.$touch()" type="password" class="form-control">
            <div v-if="$v.passwordmatch.$error" class="val-error">
              <span v-if="!$v.passwordmatch.required">Password is required.</span>
              <span v-if="!$v.passwordmatch.sameAs">Passwords must match.</span>
            </div>
          </div>
          <div class="form-group">
            <button :disabled="$v.$invalid" type="submit" class="btn btn-primary mt-3">Submit</button>
          </div>

          <div v-if="resetFail">
            <p class="bold error-text">There was an error resetting your password</p>
          </div>
        </form>
        <div v-if="resetSent">
          <p>Your password has been reset</p>
          <p>
            <router-link to="/login">Return to LevelFi login</router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import API from "@/services/api";

export default {
  data() {
    return {
      code: null,
      password: null,
      passwordmatch: null,
      resetSent: false,
      resetFail: false
    };
  },
  validations: {
    password: {
      required,
      minLength: minLength(5)
    },
    passwordmatch: {
      required,
      sameAs: sameAs("password")
    }
  },
  beforeMount() {
    // Load the reset code from the URL query
    this.code = this.$route.query.code;
  },
  methods: {
    async performReset() {
      this.resetSent = false;
      this.resetFail = false;
      try {
        await API.Reset(this.code, this.password);
        this.resetSent = true;
      } catch (err) {
        console.error(err);
        this.resetFail = true;
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue